import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Pick } from '../../core/models/cart/pick.model';
import { Real } from '../../core/models/real.model';

@Component({
  selector: 'app-terms-modal',
  templateUrl: './terms-modal.component.html',
  styleUrls: ['./terms-modal.component.scss'],
})
export class TermsModalComponent implements OnInit {


  @Input() pick: Pick;
  @Input() real: Real;

  @Input() noShowRequired: boolean;
  @Input() noShowMaxPenaltyPerPerson: number;
  @Input() paymentRequired: boolean;
  @Input() paymentAmount: number;
  @Input() minSpendRequired: boolean;
  @Input() minSpendAmountPerPerson: number;
  @Input() minSpendAmount: number;
  @Input() groupsConfirmationRequired: boolean;
  @Input() cancellationPeriod: number = 48*60;

  cancellationPeriodInHours: number = 48;
  cancellationPeriodInHoursForGroups: number = 48;

  someProtectionRequired: boolean;


  constructor( private router: Router, private modalCtrl: ModalController, public translateService: TranslateService ) { }

  ngOnInit() {

    if ( this.cancellationPeriod ) {
      this.cancellationPeriodInHours = Math.ceil(this.cancellationPeriod/60);
    }
    
    if ( this.noShowRequired || this.paymentRequired || this.minSpendRequired ) {
      this.someProtectionRequired = true;

    } else {
      this.someProtectionRequired = false; 
    }


    console.log(this.noShowRequired);
    console.log(this.paymentRequired);
    console.log(this.minSpendRequired);
    console.log('ddd');
    console.log(this.paymentAmount);
    console.log(this.minSpendAmountPerPerson);
    console.log(this.noShowMaxPenaltyPerPerson);
    console.log(this.cancellationPeriod);
    console.log(this.cancellationPeriodInHours);
    console.log(this.cancellationPeriodInHoursForGroups);

  }

  onCancel() {
    this.modalCtrl.dismiss( null, 'cancel' );
  }

  confirmTerms() {
    this.modalCtrl.dismiss( null, 'confirm' );
  }

}
